/* eslint-disable ember/no-observers */
import Helper from '@ember/component/helper';
import { isNone } from '@ember/utils';
import { addObserver } from '@ember/object/observers';

export default class AttendancePeriodStatus extends Helper {
  compute(params) {
    let [date, periodId, marked] = params;
    addObserver(marked, date + '.' + periodId, this, 'recompute');
    if (
      isNone(marked) ||
      isNone(marked[date]) ||
      isNone(marked[date][periodId])
    ) {
      return false;
    }
    return marked[date][periodId];
  }
}
